import React, { Component } from "react";

interface RenderErrorBoundaryProps {
  /** Shown in place of `children` once any of them throws while rendering. */
  fallback: React.ReactNode;
  children: React.ReactNode;
}

interface RenderErrorBoundaryState {
  hasError: boolean;
}

/**
 * Contains a render-time crash to the subtree it wraps, so a failing widget
 * (typically a third-party viewer) shows `fallback` instead of taking down the
 * whole route. Give it a `key` that changes with the widget's input to retry
 * rendering after the input changes.
 */
class RenderErrorBoundary extends Component<
  RenderErrorBoundaryProps,
  RenderErrorBoundaryState
> {
  constructor(props: RenderErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): RenderErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Render error contained by boundary:", error, info);
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}

export default RenderErrorBoundary;
